import { render } from "./AnimatedButton.vue?vue&type=template&id=987940fc&scoped=true"
import script from "./AnimatedButton.vue?vue&type=script&lang=js"
export * from "./AnimatedButton.vue?vue&type=script&lang=js"

import "./AnimatedButton.vue?vue&type=style&index=0&id=987940fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-987940fc"]])

export default __exports__